export default __webpack_public_path__ + "static/twitter-card-default-39658d1e28aa1b02b5835e1f1a1775dc.jpg";